/*!
 * Manera Downloads
 * 
 */
$(document).ready(function(){
    if ($('#downloads_nav .active').length == 0)
        $('#downloads_nav li').first().addClass('active');

    $('#downloads_nav li').on('click',function(e){
        $('#downloads_nav li').removeClass('active');
        $(this).addClass('active');
        if ($(this).hasClass('first')) { //catalogs
            TweenMax.to('#wallpapers',0.3,{opacity: 0, onComplete:function(){
                    $('#wallpapers').hide();
                    $('#catalogs').show();
                    TweenMax.to('#catalogs', .3, {opacity: 1})
                }});

        }
        if ($(this).hasClass('last')) { //wallpapers
            TweenMax.to('#catalogs',0.3,{opacity: 0, onComplete:function(){
                    $('#catalogs').hide();
                    $('#wallpapers').show();
                    TweenMax.to('#wallpapers', .3, {opacity: 1})
                }});
        }
    });

    $("[data-fancybox]").fancybox({
        autoSize: true,
        type: 'iframe',
        iframe : {
            preload: false,
            css : {
                width : '100%',
                height: '100vh',
            }
        }
    });
});